import { ISearchInput } from '../types';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { useCheckFeatureFunction } from '../../../../utils/hooks';
import { queryTypeConfigLookup } from '../../../../utils/queryTypeLookup';
import { SvgIcon } from '../../../../components/Icon';
import AdvancedSearchMenuOption from './AdvancedSearchMenuOption';
import * as AdvancedSearchMenuUI from './AdvancedSearchMenuUI';

interface IProps {
  searchInput: ISearchInput;
  setSearchInput: (searchInput: ISearchInput, isLoadMore: boolean) => void;
  supportedQueryTypes: QueryType[];
}

const QueryTypeSearchOption = ({
  searchInput,
  setSearchInput,
  supportedQueryTypes,
}: IProps) => {
  const checkFeatureFunc = useCheckFeatureFunction();

  const onClickQueryTypeOption = (queryType: QueryType, checked: boolean) => {
    const types = checked
      ? searchInput.queryTypes.filter((type) => type !== queryType)
      : [...searchInput.queryTypes, queryType];

    setSearchInput(
      {
        ...searchInput,
        queryTypes: types,
      },
      false,
    );
  };
  return (
    <AdvancedSearchMenuUI.SectionContainer>
      <AdvancedSearchMenuUI.SectionHeading>
        Report Type
      </AdvancedSearchMenuUI.SectionHeading>

      {supportedQueryTypes
        .filter((queryType) => {
          const { requiredFeature } = queryTypeConfigLookup[queryType];

          if (requiredFeature) {
            return checkFeatureFunc(requiredFeature);
          }

          return true;
        })
        .map((queryType) => {
          const { display, icon } = queryTypeConfigLookup[queryType];

          // Cohort Sample has a special label
          const label =
            queryType === QueryType.CohortSample ? 'Cohort Inspect' : display;
          const checked = searchInput.queryTypes.includes(queryType);

          return (
            <AdvancedSearchMenuOption
              key={`${queryType}-item`}
              onClick={() => onClickQueryTypeOption(queryType, checked)}
              checked={checked}
            >
              <SvgIcon
                name={icon}
                width={16}
                height={16}
                customFill="currentColor"
              />
              {label}
            </AdvancedSearchMenuOption>
          );
        })}
    </AdvancedSearchMenuUI.SectionContainer>
  );
};

export default QueryTypeSearchOption;
